import React from "react";
import { useParams } from "react-router";
import { useQuery } from "react-query";
import Container from "@material-ui/core/Container";
import PageHeader from "../../../components/PageHeader";
import { mutateErrors } from "../../../utils";
import Loading from "../../../components/Loading";
import Error from "../../../components/Error";
import useUserQueries from "../hooks/useUserQueries";
import UserAccount from "../userAccount";

export default function StudentsPage() {
  const params = useParams<{ id: string }>();
  const { fetchOne } = useUserQueries();

  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>("student_" + params.id, () => {
      return fetchOne(params.id);
    });

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  const student = data.data;

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={`${student.name}'s Account`}
          subtitle={"Here you can edit student"}
        />
      </Container>

      <UserAccount user={student} onUpdate={refetch} />
    </>
  );
}
